import React from "react";

// Lightweight markdown renderer: ##/### headings, **bold**, - lists, paragraphs.
export function MarkdownLite({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let list = [];

  const flushList = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="list-disc pl-6 space-y-1.5 my-3 text-[#3a3a3a]">
          {list.map((it, i) => (
            <li key={i}>{inline(it)}</li>
          ))}
        </ul>
      );
      list = [];
    }
  };

  const inline = (s) => {
    const regex = /(\[[^\]]+\]\([^)]+\))|(\*\*[^*]+\*\*)/g;
    const out = [];
    let last = 0;
    let key = 0;
    let m;
    while ((m = regex.exec(s)) !== null) {
      if (m.index > last) out.push(<span key={key++}>{s.slice(last, m.index)}</span>);
      const tok = m[0];
      if (tok.startsWith("**")) {
        out.push(<strong key={key++} className="font-semibold text-[#2B4A59]">{tok.slice(2, -2)}</strong>);
      } else {
        const lm = tok.match(/\[([^\]]+)\]\(([^)]+)\)/);
        out.push(
          <a key={key++} href={lm[2]} target="_blank" rel="noopener noreferrer" className="text-[#B5651D] underline font-medium">
            {lm[1]}
          </a>
        );
      }
      last = regex.lastIndex;
    }
    if (last < s.length) out.push(<span key={key++}>{s.slice(last)}</span>);
    return out;
  };

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (line.startsWith("### ")) {
      flushList(idx);
      blocks.push(<h4 key={idx} className="font-serif text-xl mt-5 mb-1 text-[#3F6E85]">{line.slice(4)}</h4>);
    } else if (line.startsWith("## ")) {
      flushList(idx);
      blocks.push(<h3 key={idx} className="font-serif text-2xl mt-6 mb-2 text-[#2B4A59]">{line.slice(3)}</h3>);
    } else if (line.startsWith("# ")) {
      flushList(idx);
      blocks.push(<h2 key={idx} className="font-serif text-3xl mt-6 mb-2">{line.slice(2)}</h2>);
    } else if (/^\s*([-*_])\1{2,}\s*$/.test(line)) {
      flushList(idx);
      blocks.push(<hr key={idx} className="my-4 border-t border-[#3F6E85]/15" />);
    } else if (/^\s*[-*]\s+/.test(line)) {
      list.push(line.replace(/^\s*[-*]\s+/, ""));
    } else if (/^\s*\d+\.\s+/.test(line)) {
      list.push(line.replace(/^\s*\d+\.\s+/, ""));
    } else if (line.trim() === "") {
      flushList(idx);
    } else {
      flushList(idx);
      blocks.push(<p key={idx} className="my-2 text-[#3a3a3a] leading-relaxed">{inline(line)}</p>);
    }
  });
  flushList("end");
  return <div>{blocks}</div>;
}
